import AccordianItem, { AccordianItemProps } from './AccordianItem'

export default AccordianItem
export { AccordianItem }
export type { AccordianItemProps }
